import { Injectable } from '@angular/core';

import {
    CanActivate,
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot
} from '@angular/router';

import { CorePaths } from '../modules/core/core-routing.module';
import { AuthService } from '../services/auth.service';
import { IUserInfo } from '../models/user';
import { UserPaths } from '../modules/user/user-paths';

@Injectable({
    providedIn: 'root'
})
export class ParentalGateGuard implements CanActivate {

    constructor(private authService: AuthService, private router: Router) {
    }

    get isAuthorisedUser() {
        const tokenInfo = this.authService.getDecodedToken();
        if (tokenInfo) {
            return (tokenInfo?.['UserInfo'] as IUserInfo)?.PrimarySubscription == null;
        }
        return false;
    }

    get isVerified() {
        const tokenInfo = this.authService.getDecodedToken();
        if (tokenInfo) {
            return (tokenInfo?.['ParentalToken'] === 'True');
        }
        return false;

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        const isParentalGateRoute =
            route.routeConfig?.path === CorePaths.parentalGate;

        // Prevent verified users from opening the parental gate page
        if (isParentalGateRoute) {
            if (!this.isVerified) {
                return true;
            }

            this.router.navigateByUrl(UserPaths.home);
            return false;
        }

        // If user is already verified, let him access the page
        if (this.isVerified || this.isAuthorisedUser) {
            return true;
        }

        // navigate to Parental Gate verification
        this.router.navigate(
            [`/${CorePaths.parentalGate}`],
            {
                queryParams: {
                    returnUrl: state.url,
                }
            }
        );

        return false;
    }

}
